import {
  CANVAS_HEIGHT_PX,
  CANVAS_WIDTH_PX,
  clampFrameToCanvas,
  type CanvasFrame,
} from "@refinement-canvas/domain";

// アスペクト比を保ったままフレームをキャンバス内へ収める。
// 通常の clampFrameToCanvas は w と h を個別にキャンバス幅・高さへ丸めるため、巨大ドラッグで
// 境界に達すると縦横比が崩れる。アスペクト比固定（画像・動画・スタンプ）の四隅リサイズでは、
// w / h を同一スケールで縮小してから位置を clamp し、境界到達時も比率を維持する。
export function clampAspectFrameToCanvas<T extends CanvasFrame>(frame: T): T {
  // w / h が不正（NaN・0 以下）なら従来の clamp にフォールバックする（比率を保てないため）。
  if (
    !Number.isFinite(frame.w) ||
    !Number.isFinite(frame.h) ||
    frame.w <= 0 ||
    frame.h <= 0
  ) {
    return clampFrameToCanvas(frame);
  }
  // w / h を同じ係数で縮小して両軸ともキャンバスへ収める（比率維持）。
  const scale = Math.min(1, CANVAS_WIDTH_PX / frame.w, CANVAS_HEIGHT_PX / frame.h);
  const w = frame.w * scale;
  const h = frame.h * scale;
  return {
    ...frame,
    x: clamp(frame.x, 0, Math.max(0, CANVAS_WIDTH_PX - w)),
    y: clamp(frame.y, 0, Math.max(0, CANVAS_HEIGHT_PX - h)),
    w,
    h,
  };
}

function clamp(value: number, min: number, max: number): number {
  if (!Number.isFinite(value)) return min;
  if (max < min) return 0;
  return Math.min(max, Math.max(min, value));
}
